import React from 'react';
import { Layout } from 'components/ingredientDetail/Index';
import { FmlxModal } from 'fmlx-common-ui';
import { RMModal } from 'components/modal';

interface Props {
  ingredientId: number;
  showModal: boolean;
  setShowModal: any;
}

const DetailView = (props: Props) => {
  const { ingredientId, showModal, setShowModal } = props;
  const onCancel = () => {
    setShowModal(false);
  };

  return (
    <RMModal
      id="ingredient-detailview-modal"
      showModal={showModal}
      onHide={() => setShowModal(false)}
      onCancel={onCancel}
      dialogClassName="ingredient-Modal"
      body={<Layout ingredientId={ingredientId} closeModal={onCancel} />}
      isCancelOnly={true}
      setShowModal={setShowModal}
      size={FmlxModal.Size.LARGE}
      showButtons={false}
    />
  );
};

export default DetailView;
